module.exports = __webpack_public_path__ + "static/media/tg.210dfafe.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tg.svg
// module id = 2222
// module chunks = 0